import {
  FilterType,
  buildBudgetMovementsDatatableFilter,
  useBudgetMovementsDatatable,
} from 'generated/resources/datatable.graphql'
import { ExpenseCategoryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  source: ReturnType<typeof useBudgetMovementsDatatable>
  categories: ExpenseCategoryFragment[]
}

const CategoryFilter = ({ source, categories }: Props) => {
  const options = categories.map((category) => {
    return {
      value: category.id,
      label: category.label,
    }
  })

  return buildBudgetMovementsDatatableFilter(source, {
    path: 'expensableCategory',
    identifier: 'budgetMovements.expensableCategory',
    type: FilterType.String,
    title: i18n.t('budgets.detail.tabs.spendings.table.filters.category'),
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    default: true,
  })
}

export default CategoryFilter
